//Import the necessary Fontawesome icons
import fontawesome from '@fortawesome/fontawesome';
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook';
import faGooglePlus from '@fortawesome/fontawesome-free-brands/faGooglePlus';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faLinkedin from '@fortawesome/fontawesome-free-brands/faLinkedin';
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';

require('./assets/css/main.scss');

fontawesome.library.add(faTwitter,faGooglePlus,faFacebook,faInstagram,faLinkedin);



// WEBPACK FOOTER //
// /Users/brockduncan/Sites/zonedcomfort/wp-content/mu-plugins/vendor/underpin/social-media/index.js